export function retrieveValueAtProperty(queryElements, property, defaultValue) {
  const queryValue = queryElements.get(property);
  if (queryValue !== null) {
    return queryValue;
  }

  // const sessionValue = sessionStorage.getItem(property);
  // if (sessionValue !== null && sessionValue !== "undefined") {
  //   return sessionValue;
  // }

  const value =
    window["experimentalFunctions"]?.[property] ??
    window[property] ??
    defaultValue;
  return typeof value === "function" ? value() : value;
}
